const organization = {
    require_membership: 'ユーザーは組織のメンバーである必要があります。',
};
export default Object.freeze(organization);
